











import { Prop, Component, Vue } from "vue-property-decorator";
import { GridMask, GridMaskColumn } from "../viewmodels/grid-mask";

@Component
export default class VGridMask extends Vue implements GridMask {
  @Prop({ default: () => [] }) cols!: GridMaskColumn[];
}
